import devConfig from "./config.dev.json";
import prodConfig from "./config.prod.json";

//const config = process.env.NODE_ENV === "production" ? prodConfig : devConfig; // to run in local
// eslint-disable-next-line no-self-compare
const config = "production" === "production" ? prodConfig : devConfig; // to run in prod

// Replace variables dynamically
/*config.cognitoDomain = config.cognitoDomain
  .replace("${cognitoDomain}",config.cognitoDomain)
  .replace("${clientId}", config.clientId)
  .replace("${logoutUri}", config.logoutUri);*/

export default config;
